import { FC, ReactNode } from 'react'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { useTranslation } from 'react-i18next'

type PerPopoverFooterProps = {
  cancelButtonHidden?: boolean
  okButtonHidden?: boolean
  cancelButtonDisabled?: boolean
  okButtonDisabled?: boolean
  onClickCancel: () => void
  onClickConfirm: () => void
  tooltip?: ReactNode
  isProcessing?: boolean
}

export const PerPopoverFooter: FC<PerPopoverFooterProps> = ({
  cancelButtonHidden = false,
  okButtonHidden = false,
  cancelButtonDisabled = false,
  okButtonDisabled = false,
  onClickCancel,
  onClickConfirm,
  tooltip,
  isProcessing = false,
}) => {
  const [t] = useTranslation()
  return (
    <PerFlexRow
      justify={okButtonHidden ? 'start' : cancelButtonHidden ? 'end' : 'space-between'}
      align="middle"
      className="per-popover_footer"
    >
      {!cancelButtonHidden && (
        <PerButtonCircle
          color="secondary"
          icon="close_stroke"
          variant="pastel"
          tooltip={t('tooltip.cancel')}
          disabled={cancelButtonDisabled}
          onClick={onClickCancel}
        />
      )}
      {!okButtonHidden && (
        <PerButtonCircle
          color="success"
          icon="check_stroke"
          variant="pastel"
          tooltip={tooltip ? tooltip : t('tooltip.confirm')}
          disabled={okButtonDisabled}
          onClick={onClickConfirm}
          isProcessing={{ active: isProcessing }}
        />
      )}
    </PerFlexRow>
  )
}
